// ABOUTME: Responsive grid of StatCards that colours them in a fixed order by position.
// ABOUTME: Keeps every overview row looking the same without each view picking colours itself.

import { Box } from "@mui/material";
import { Children, cloneElement, isValidElement } from "react";
import { STAT_CARD_COLORS } from "./StatCard";

/**
 * StatCardRow
 *
 * Wraps a row of <StatCard>s in the shared overview grid and hands each one its colour from
 * STAT_CARD_COLORS by position, so two different views showing six figures colour them the
 * same way. A card that names its own `color` keeps it, and the sequence wraps around for
 * rows longer than the list.
 *
 * - columns: cards per row on a wide screen (default 3). Below 78em it drops to two and on a
 *   phone to one, matching the rest of the overview pages.
 * - sx: merged into the grid, for callers that need their own spacing around it.
 */
const StatCardRow = ({ children, columns = 3, sx }) => {
    let index = 0;

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
                gap: 2,
                "@media screen and (max-width: 78em)": {
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
                },
                "@media screen and (max-width: 47.9375em)": {
                    gridTemplateColumns: "minmax(0, 1fr)"
                },
                ...sx
            }}
        >
            {Children.map(children, (child) => {
                // Conditionally rendered cards come through as false or null; they take no
                // colour from the sequence so the ones that do render keep their order.
                if (!isValidElement(child)) {
                    return child;
                }

                const color = child.props.color ?? STAT_CARD_COLORS[index % STAT_CARD_COLORS.length];
                index++;

                return cloneElement(child, { color });
            })}
        </Box>
    );
};

export default StatCardRow;
